//This re-export is necessary since webpack seems to be unable to
//to resolve the module as usual without this
import store from "./store/index";
export default store;